var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CFooter',{attrs:{"fixed":false}},[_c('div',[_vm._v(" CargoMX "),_c('span',{staticClass:"ml-1"},[_vm._v("© 2024.")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }